import _extends from '@babel/runtime-corejs3/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/esm/objectWithoutProperties';
import React, { forwardRef, cloneElement } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import bemCnFast from '@webteam/bem-cn-fast';
import { useTheme } from '@rescui/ui-contexts';
import localNames from '../index.pcss.js';
import { ListContextInner } from './list-context-inner.js';

var bemCn = bemCnFast('wt-list-item', localNames);
var ListItem = forwardRef(function ListItem(_ref, ref) {
  var className = _ref.className,
      propsTag = _ref.tag,
      children = _ref.children,
      icon = _ref.icon,
      _ref$onClick = _ref.onClick,
      _onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$size = _ref.size,
      propsSize = _ref$size === void 0 ? 'm' : _ref$size,
      _ref$mode = _ref.mode,
      propsMode = _ref$mode === void 0 ? 'cell' : _ref$mode,
      propsTheme = _ref.theme,
      disabledFromProps = _ref.disabled,
      selectedFromProps = _ref.selected,
      highlighted = _ref.highlighted,
      _ref$iconPlacement = _ref.iconPlacement,
      propsIconPlacement = _ref$iconPlacement === void 0 ? 'left' : _ref$iconPlacement,
      restProps = _objectWithoutProperties(_ref, ["className", "tag", "children", "icon", "onClick", "size", "mode", "theme", "disabled", "selected", "highlighted", "iconPlacement"]);

  var theme = useTheme(propsTheme);
  return React.createElement(ListContextInner.Consumer, null, function (_ref2) {
    var contextIconPlacement = _ref2.iconPlacement,
        disabled = _ref2.disabled,
        size = _ref2.size,
        mode = _ref2.mode,
        contextTheme = _ref2.theme,
        itemTag = _ref2.itemTag,
        _ref2$onItemClick = _ref2.onItemClick,
        onItemClick = _ref2$onItemClick === void 0 ? function () {} : _ref2$onItemClick,
        value = _ref2.value;
    var Tag = propsTag || itemTag;
    var iconPlacement = contextIconPlacement || propsIconPlacement || 'left';
    return React.createElement(Tag, _extends({
      ref: ref,
      className: cn(bemCn({
        placement: iconPlacement,
        disabled: disabled || disabledFromProps,
        mode: mode || propsMode,
        size: size || propsSize,
        theme: contextTheme || theme,
        selected: selectedFromProps,
        highlighted: highlighted
      }), className),
      onClick: function onClick(e) {
        _onClick(e);

        onItemClick(value, e);
      },
      "data-test": 'list-item'
    }, restProps), iconPlacement === 'left' && icon && cloneElement(icon, {
      className: cn(icon.props.className, bemCn('icon', {
        placement: iconPlacement
      }))
    }), React.createElement("span", {
      className: bemCn('content')
    }, children), iconPlacement === 'right' && icon && cloneElement(icon, {
      className: cn(icon.props.className, bemCn('icon', {
        placement: iconPlacement
      }))
    }));
  });
});
ListItem.propTypes = {
  size: PropTypes.oneOf(['l', 'm', 's', 'xs']),
  mode: PropTypes.oneOf(['nude', 'cell']),
  theme: PropTypes.oneOf(['light', 'dark']),

  /** @ignore */
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  highlighted: PropTypes.bool,
  icon: PropTypes.node,
  iconPlacement: PropTypes.oneOf(['left', 'right']),
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType])
};

export { ListItem };
